var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "44161893-0091-4483-9FBF-0204D5623310") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-57.5270968%",
    y1: "50.1241953%",
    x2: "232.39121%",
    y2: "50.1241953%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.182516704%",
    y1: "49.95997%",
    x2: "100.273441%",
    y2: "49.95997%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-62.8015845%",
    y1: "49.8578253%",
    x2: "253.671294%",
    y2: "49.8578253%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.175556793%",
    y1: "50.0058048%",
    x2: "101.808162%",
    y2: "50.0058048%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004E94",
    offset: "47.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B1",
    offset: "82.61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.575855512%",
    y1: "49.9142191%",
    x2: "98.13299%",
    y2: "49.9142191%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#882730",
    offset: "17.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1833",
    offset: "57.31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0436",
    offset: "85.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60039",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK-Full---Plans---6:BillingCreditCards",
    transform: "translate(-64.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Due-Section-Copy-7",
    transform: "translate(48.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JCB-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "JCB_logo",
    transform: "translate(8.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,14.7579462 C24,16.8117359 22.3276284,18.4841076 20.2738386,18.4841076 L0,18.4841076 L0,3.72616137 C0,1.67237164 1.67237164,0 3.72616137,0 L24,0 L24,14.7579462 Z",
    id: "path6325",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327",
    transform: "translate(16.078240, 1.246944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3202934,9.72616137 L2.8606357,9.72616137 C2.90464548,9.72616137 3.00733496,9.71149144 3.05134474,9.71149144 C3.34474328,9.65281174 3.59413203,9.38875306 3.59413203,9.02200489 C3.59413203,8.66992665 3.34474328,8.40586797 3.05134474,8.33251834 C3.00733496,8.31784841 2.9193154,8.31784841 2.8606357,8.31784841 L1.3202934,8.31784841 L1.3202934,9.72616137 Z",
    id: "path6338",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68459658,0 C1.21760391,0 0.0146699267,1.18826406 0.0146699267,2.66992665 L0.0146699267,5.44254279 L3.78484108,5.44254279 C3.87286064,5.44254279 3.97555012,5.44254279 4.04889976,5.45721271 C4.8997555,5.50122249 5.53056235,5.94132029 5.53056235,6.70415648 C5.53056235,7.30562347 5.10513447,7.8190709 4.31295844,7.92176039 L4.31295844,7.95110024 C5.17848411,8.00977995 5.83863081,8.49388753 5.83863081,9.24205379 C5.83863081,10.0488998 5.10513447,10.5770171 4.13691932,10.5770171 L-4.16944393e-15,10.5770171 L-4.16944393e-15,16.00489 L3.91687042,16.00489 C5.38386308,16.00489 6.58679707,14.8166259 6.58679707,13.3349633 L6.58679707,0 L2.68459658,0 Z",
    id: "path6349",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40342298,6.8801956 C3.40342298,6.52811736 3.15403423,6.29339853 2.8606357,6.24938875 C2.83129584,6.24938875 2.75794621,6.23471883 2.71393643,6.23471883 L1.3202934,6.23471883 L1.3202934,7.52567237 L2.71393643,7.52567237 C2.75794621,7.52567237 2.84596577,7.52567237 2.8606357,7.51100244 C3.15403423,7.46699267 3.40342298,7.23227384 3.40342298,6.8801956 L3.40342298,6.8801956 Z",
    id: "path6360",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.00488998,1.24694377 C2.53789731,1.24694377 1.33496333,2.43520782 1.33496333,3.91687042 L1.33496333,10.5036675 C2.08312958,10.8704156 2.8606357,11.1051345 3.63814181,11.1051345 C4.56234719,11.1051345 5.06112469,10.5476773 5.06112469,9.78484108 L5.06112469,6.67481663 L7.34963325,6.67481663 L7.34963325,9.77017115 C7.34963325,10.9731051 6.60146699,11.9559902 4.06356968,11.9559902 C2.52322738,11.9559902 1.3202934,11.6185819 1.3202934,11.6185819 L1.3202934,17.2371638 L5.23716381,17.2371638 C6.70415648,17.2371638 7.90709046,16.0488998 7.90709046,14.5672372 L7.90709046,1.24694377 L4.00488998,1.24694377 Z",
    id: "path6371",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3838631,1.24694377 C9.91687042,1.24694377 8.71393643,2.43520782 8.71393643,3.91687042 L8.71393643,7.40831296 C9.38875306,6.83618582 10.5623472,6.46943765 12.4547677,6.55745721 C13.4669927,6.60146699 14.5525672,6.8801956 14.5525672,6.8801956 L14.5525672,8.00977995 C14.00978,7.73105134 13.3643032,7.48166259 12.5281174,7.42298289 C11.0904645,7.3202934 10.2249389,8.02444988 10.2249389,9.25672372 C10.2249389,10.5036675 11.0904645,11.207824 12.5281174,11.0904645 C13.3643032,11.0317848 14.00978,10.7677262 14.5525672,10.5036675 L14.5525672,11.6332518 C14.5525672,11.6332518 13.4816626,11.9119804 12.4547677,11.9559902 C10.5623472,12.0440098 9.38875306,11.6772616 8.71393643,11.1051345 L8.71393643,17.2665037 L12.6308068,17.2665037 C14.0977995,17.2665037 15.3007335,16.0782396 15.3007335,14.596577 L15.3007335,1.24694377 L11.3838631,1.24694377 Z",
    id: "path6384",
    fill: "url(#linearGradient-5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCard);
export default __webpack_public_path__ + "static/media/jcb-card.187957687e3b90e485d1265b8ebfd532.svg";
export { ForwardRef as ReactComponent };